"use strict";

(function () {
    var directiveId = "dateTimePicker";
    //requires jquery.scrollTableBody-1.0.0.js
    angular.module("fleetviewApp").directive(directiveId, function () {
        return {
            restrict: "A",
            replace: true,
            scope: false,
            link: function link(scope, element, attrs /*, ngModel*/) {
                //var input = element.find('input');
                var pickerOpt = {
                    format: "m/dd/yyyy hh:ii",
                    minView: 0,
                    maxView: 3,
                    showMeridian: false,
                    autoclose: true,
                    todayHighlight: true,
                    bootcssVer: 3,
                    pickerPosition: "bottom-right"
                };
                var iconClass = "glyphicon-th";
                switch (attrs.dateTimePicker) {
                    case "date":
                        pickerOpt.minView = 2;
                        pickerOpt.format = "m/dd/yyyy";
                        break;
                    case "time":
                        pickerOpt.maxView = 1;
                        pickerOpt.startView = 1;
                        pickerOpt.format = "hh:ii";
                        pickerOpt.showMeridian = true;
                        iconClass = "glyphicon-time";
                        pickerOpt.pickerPosition = "bottom-right dontshowdate";
                        break;
                }
                element.find(".glyphicon").addClass(iconClass);
                element.datetimepicker(pickerOpt);

                //element.bind('blur keyup change', function () {
                //  scope.ngModel = input.val();
                //});
            }
        };
    });
})();


// WEBPACK FOOTER //
// ./app/components/datetimepick.directive.js